module.exports = __webpack_public_path__ + "img/chevron.16019ed4.svg";